import { addressToString, mlsInfoByOUID, parseToolkitListingID } from '@aloft/toolkit-shared';
import { CompSelectionProperty } from '../types.ts';

const HEADER_ROW = [
  'Address',
  'MLS Name',
  'MLS Listing ID',
  'MLS Status',
  'Distance to Subject (miles)',
  'Similarity Score',
  'Property Type',
  'Sale Price',
  'Sale Date',
  'Contract Date',
  'Cumulative Days on Market',
  'List Price',
  'List Date',
  'Quality Tier',
  'GLA (sqft)',
  'Lot Size (sqft)',
  'Year Built',
  'Bedrooms',
  'Full Baths',
  'Half Baths',
  'Basement (Y/N)',
  'Garage (Y/N)',
  'Garage Stalls',
  'Lat;Lon',
  'REO (Y/N)',
  'Short Sale (Y/N)',
];

const cleanRow = (row: string[]): string[] => row.map((cell) => {
  if (cell.includes(',') || cell.includes('"') || cell.includes('\n')) {
    return `"${cell.replace(/"/g, '""')}"`;
  }
  return cell;
});


const convertRecommendedCompsToCSVData = (comps: CompSelectionProperty[]) => {
  const csvData: string[][] = [HEADER_ROW];

  comps.forEach((comp) => {
    const toolkitListingId = comp.listingID;
    let mlsName = '';
    let mlsListingId = '';
    if (toolkitListingId) {
      const mlsOUID = parseToolkitListingID(toolkitListingId).mls;
      mlsName = mlsInfoByOUID(mlsOUID)?.shortName ?? '';
      mlsListingId = parseToolkitListingID(toolkitListingId).listingID;
    }
    const row: string[] = [
      addressToString(comp.address ?? {}),
      mlsName ?? '',
      mlsListingId ?? '',
      comp.mlsStatus ?? '',
      comp.distanceToSubject !== undefined ? comp.distanceToSubject.toString() : '',
      comp.similarityScore !== undefined ? comp.similarityScore.toFixed(2) : '',
      comp.propertyType ?? '',
      comp.salePrice !== undefined ? comp.salePrice.toDollarLike().toString() : '',
      comp.saleDate?.toString() ?? '',
      comp.contractDate?.toString() ?? '',
      comp.cumulativeDaysOnMarket !== undefined ? comp.cumulativeDaysOnMarket.toString() : '',
      comp.listPrice !== undefined ? comp.listPrice.toDollarLike().toString() : '',
      comp.listingContractDate?.toString() ?? '',
      comp.qualityTier ? comp.qualityTier.toString() : '',
      comp.gla !== undefined ? comp.gla.toSqFt().getUnitAmount().toString() : '',
      comp.lotSize !== undefined ? comp.lotSize.toSqFt().getUnitAmount().toString() : '',
      comp.yearBuilt !== undefined ? comp.yearBuilt.toString() : '',
      comp.bedrooms !== undefined ? comp.bedrooms.toString() : '',
      comp.fullBaths !== undefined ? comp.fullBaths.toString() : '',
      comp.halfBaths !== undefined ? comp.halfBaths.toString() : '',
      comp.basement !== undefined ? (comp.basement ? 'Y' : 'N') : '',
      comp.garage !== undefined ? (comp.garage ? 'Y' : 'N') : '',
      comp.garageCount !== undefined ? comp.garageCount.toString() : '',
      (comp.latitude !== undefined && comp.longitude !== undefined) ? `${comp.latitude};${comp.longitude}` : '',
      comp.reo !== undefined ? (comp.reo ? 'Y' : 'N') : '',
      comp.shortSale !== undefined ? (comp.shortSale ? 'Y' : 'N') : '',
    ];

    csvData.push(cleanRow(row));
  });

  return csvData;
};

export const convertRecommendedCompsToCSV = (comps: CompSelectionProperty[]): string => {
  const csvData = convertRecommendedCompsToCSVData(comps);
  return csvData.map((row) => row.join(',')).join('\n');
};
